import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { fetchSyncJobs } from '../api/syncJobsApi';
import type { SyncJobsQuery } from '../types';

export function useSyncJobs(query: SyncJobsQuery) {
  return useQuery({
    queryKey: [
      'sync-jobs',
      {
        startDate: query.startDate.toISOString().slice(0, 10),
        endDate: query.endDate.toISOString().slice(0, 10),
        searchParam: query.searchParam,
        page: query.page,
        pageSize: query.pageSize,
        sortCol: query.sortCol,
        sortDir: query.sortDir,
      },
    ],
    queryFn: () => fetchSyncJobs(query),
    placeholderData: keepPreviousData,
  });
}
